module.exports = __webpack_public_path__ + "static/media/business.c24e1bff.svg";